export const cards = [
  {
    product_name: "Padaria: Aqui servimos mistério",
    serie_name: "Padaria",
    author: "Gislene Vieira de Lima",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Magia", "Sobrenatural", "Folclore"],
    valores: [24.9, 57.9],
    isNew: false,
    thumbnail: require("../assests/capas/padaria.jpg"),
    product_card_colors: ["#395839", "#C62B6D"],
    description:
      "Se algum dia, caminhando por uma rua, você se deparar com uma padaria chamada PADARIA, aproveite essa oportunidade única! Em meio a deliciosas guloseimas, visite esse lugar maravilhoso onde as criaturas fantásticas mais inusitadas do folclore brasileiro circulam livremente, e onde nada é o que parece ser. Entretanto, fique esperto! Entrar em contato com esses mistérios pode te arremessar em aventuras que vão além de sua imaginação, você as entendendo ou não.",
  },
  {
    product_name: "A Princesa com Olhos de Gato",
    serie_name: "A Princesa com Olhos de Gato",
    author: "Gislene Vieira de Lima",
    selo: "Pandora",
    tags: ["Fantasia", "Magia", "Infanto-juvenil", "Aventura"],
    valores: [29.9, 68.9],
    isNew: false,
    thumbnail: require("../assests/capas/princesa-olhos-gato.png"),
    product_card_colors: ["#395839", "#C62B6D"],
    description:
      "A Princesa com Olhos de Gatos nos leva através de um conto de fadas complexo. Nada de príncipes resgatando as moças que foram manipuladas pelas forças malignas. Nada de fada madrinha aparecendo para ajudar a superar os obstáculos. Aqui, a própria princesa vai atrás de respostas e enfrenta o seu destino. O aprendiz de mago precisa se mostrar digno para a magia aceitá-lo como seu representante. A morte pode ser a mais bem-vinda amiga, e a verdade pode estar atrás de um espelho ou bem diante dele.",
  },

  {
    product_name: "O Anatomista de Dragões",
    serie_name: "Dragão de Vapor",
    author: "Alexandre Kalfeld",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Steampunk", "Aventura", "Dragões", "Biopunk"],
    valores: [34.9, 77.9],
    isNew: false,
    thumbnail: require("../assests/capas/anatomista-dragoes.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Jhonatan é um jovem do interior apaixonado por dragões, seres ameaçados de extinção devido ao avanço tecnológico da Revolução Industrial e Bélica do início do século XX. Sua paixão, cicatrizes de guerra e obsessão por conhecimento consequentemente o levam a travar uma luta contra um inimigo muito mais voraz que os próprios dragões. Toda a sua vida é então dedicada a preservar essas criaturas, que desde a antiguidade são usadas como armas de guerra, e retirar delas o manto dos mitos supersticiosos, antes que a ignorância as faça desaparecer.",
  },

  {
    product_name: "O Véu de Organza",
    serie_name: "O Véu de Organza",
    author: "Alexandre Kalfeld",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Sobrenatural", "Terror", "Aventura"],
    valores: [34.9, 79.9],
    isNew: false,
    thumbnail: require("../assests/capas/veu-de-organza.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Emílio Valtasar trabalha para Charlie, um velho inglês em um antiquário, junto com Marcos, um jovem que nasceu com habilidades especiais de manipulação espiritual, e seu trabalho vai além de vender e comprar antiguidades. Quando um homem, que diz ser da antiga família dos Nephilins, chega na cidade e desperta uma entidade petulante, uma caçada se inicia indo em contramão de terríveis feiticeiros da carne, envolvendo os letárgicos funcionários do antiquário em uma desastrosa demanda em busca de uma joia que pode abalar o Véu.",
  },
  {
    product_name: "Princess versus Witch",
    serie_name: "Versus",
    author: "Lhaisa Andria & Paula Vendramini",
    selo: "Pandora",
    tags: ["Fantasia", "Infanto-juvenil", "Mundo mágico", "Conto de fadas"],
    valores: [39.9, 64.9],
    isNew: false,
    thumbnail: require("../assests/capas/princess-vs-witch.jpg"),
    product_card_colors: ["#B78E4F", "#393A56"],
    description:
      "Toda maldição pode se tornar um destino, se o pedido for sincero. Na Floresta dos Sem-Voltas, a felicidade da bruxa Majori em finalmente ter se graduado como aprendiz é desfeita ao receber a notícia do noivado da princesa Yuria. O compromisso assumido traria para o Reino da Chuva o seu inimigo mais temido: o sol. Em uma medida extrema para impedir os acontecimentos, Majori e Yuria trocam de aparência, e com isso desencadeiam uma série de episódios que acordarão o passado congelado, e mergulhará os Reinos novamente em escuridão.",
  },
  {
    product_name: "Reino de Sangue",
    serie_name: "Reino de Sangue",
    author: "Victória Neumann",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Sobrenatural", "Vampiros", "Realeza"],
    valores: [0, 53.9],
    isNew: true,
    thumbnail: require("../assests/capas/reino-de-sangue.jpg"),
    product_card_colors: ["#B78E4F", "#393A56"],
    description:
      "Vaughn é um enfermeiro que trabalha em um hospital de Londres e leva uma vida perfeitamente comum e solitária. Contudo, por trás dessa máscara de pessoa comum esconde um segredo: ele é um vampiro que faz parte da família Real vampírica, e foi transformado pelo próprio Rei de Londres.\nDesanimado com as futilidades da Corte, ele renegou sua posição e optou por viver como humano. Porém, quando descobre que seu ‘pai’ vampiro está morto e que a linha de sucessão para o trono vai direto à sua casa, Vaughn é forçado a voltar para evitar sua própria coroação.",
  },
  {
    product_name: "Allison Hupgrade - Identidade Programada",
    serie_name: "Hupgrade",
    author: "Rodrigo Guedes",
    selo: "Pandora",
    tags: ["Fantasia", "Ficção Científica", "Futurismo", "Povos originários", "Genética"],
    valores: [29.9, 57.9],
    isNew: false,
    thumbnail: require("../assests/capas/allison-hupgrade.png"),
    product_card_colors: ["#B78E4F", "#393A56"],
    description:
      "Nessa história incrível em uma Florianópolis tecnológica e decadente, acompanhamos a jornada de Allison, uma game designer dividida por dois mundos: o tecnológico em que vive e o indígena de onde tem origem. Essa divisão traz consigo os principais conflitos que regem toda a trama: o moderno e o ancestral. Assim como no mundo de hoje, existe o que é seguro, testado e licenciado, e as alternativas não indicadas da deep web. Porém, diferente do que temos atualmente, um programa pirata não vai danificar o seu computador, celular ou tablet, mas sim o seu próprio corpo.",
  },
  {
    product_name: "A Menina, o broto e o jardim",
    serie_name: "Broto",
    author: "Daniela Valiente",
    selo: "Pandora",
    tags: ["Fantasia", "Desenvolvimento Pessoal", "Jardim", "Ilustrado"],
    valores: [0, 29.9],
    isNew: false,
    thumbnail: require("../assests/capas/broto.png"),//falta
    product_card_colors: ["#B78E4F", "#393A56"],
    description:
      "Com ilustrações e poesia, a menina e o seu broto nos levam por uma jornada de vida, onde aprendemos que o tempo é o nosso jardim, o que cultivamos nele é a nossa vida. Daniela Valiente é jornalista e atualmente reside em Foz do Iguaçu, onde tem sua trajetória ligada com a cultura artística produções gráficas e escritas da cidade.",
  },
  {
    product_name: "Felipe Caterluci e o Livro dos Desejos",
    serie_name: "Felipe Caterluci",
    author: "Tiago C. Luciano",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Infantojuvenil", "Aventura", "Samurais", "Magia", "Universos Paralelos"],
    valores: [29.9, 69.9],
    isNew: false,
    thumbnail: require("../assests/capas/felipe-caterluci-livro-dos-desejos.jpg"),
    product_card_colors: ["#B78E4F", "#393A56"],
    description:
      "Até completar seus doze anos, Felipe vive normalmente como qualquer menino em uma cidade pequena do interior. Mas depois de entrar em uma loja um tanto estranha no dia do seu aniversário e ganhar um livro velho, nada mais será o mesmo. Ele descobre que as histórias sobrenaturais que sempre ouviu pela cidade podem não ser tão irreais assim, e tudo fica mais estranho quando seu avô é sequestrado por criaturas misteriosas. Então, armado com seu livro e seus melhores amigos, o menino parte para outro mundo, onde deverá descobrir toda a sua força para proteger quem ama.",
  },
  {
    product_name: "Felipe Caterluci e o Último Samurai",
    serie_name: "Felipe Caterluci",
    author: "Tiago C. Luciano",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Infantojuvenil", "Aventura", "Samurais", "Magia", "Universos Paralelos"],
    valores: [0, 64.9],
    isNew: true,
    thumbnail: require("../assests/capas/felipe-caterluci-ultimo-samurai.jpg"),
    product_card_colors: ["#B78E4F", "#393A56"],
    description:
      "Três anos após sua aventura em outro mundo, Felipe tentava levar uma vida comum com seus amigos. Mas a paz foi interrompida por misteriosos desaparecimentos em Santa Fé. Durante a investigação, a visita de um antigo aliado o leva de volta a Audacius. Lá, ele descobre a ligação sombria entre os sequestros e um mal ainda maior. Para enfrentá-lo, precisará enfrentar seus maiores medos, reunir velhos e novos amigos e provar sua coragem.",
  },

  {
    product_name: "Rosa Imortal 1: Um Novo Florescer",
    serie_name: "Rosa Imortal",
    author: "Tâni Falabello",
    selo: "Pandora",
    tags: ["Fantasia", "Sobrenatural", "Policial", "Espionagem", "Vampiros"],
    valores: [39.9, 64.9],
    isNew: false,
    thumbnail: require("../assests/capas/rosa-imortal-1.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "A história nos leva à Londres dos anos 1960, onde a jovem jornalista Eileen Hartmann se vê envolvida numa série de assassinatos do corpo diplomático. A trama se complica com o desaparecimento de seu namorado, o agente federal Jason Pearson, levando Eileen a adentrar em um mundo paralelo e desconhecido, que ela acreditava só existir em lendas urbanas. Uma história envolvente que leva o leitor a conhecer os mais vis segredos de uma política paralela em Londres, onde seres ancestrais governam e se digladiam por poder, num jogo de intrigas e trapaças, onde os humanos são meros peões descartáveis.",
  },
  {
    product_name: "Rosa Imortal 2: Sangue & Espinhos",
    serie_name: "Rosa Imortal",
    author: "Tâni Falabello",
    selo: "Pandora",
    tags: ["Fantasia", "Sobrenatural", "Policial", "Espionagem", "Vampiros"],
    valores: [39.9, 64.9],
    isNew: false,
    thumbnail: require("../assests/capas/rosa-imortal-2.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Pontuado por cenas em flashback, que explica muito sobre alguns personagens, o enredo traz personagens novos e uma trama policial de tirar o fôlego!\nEnvolva-se com alguns policiais britânicos que, entediados com a rotina seu trabalho diário, resolvem envolver-se em um caso fantástico, mais do que sequer podiam imaginar. Envolva-se novamente por Eileen e Fabian, por Loren e Marcello, reencontre-se com Thomas e Ann… e permita-se conhecer Benjamin, Paola, Simon, Yoshimi, Robin… Não se esqueça, no entanto, de que mesmo as mais belas rosas têm espinhos!",
  },
  {
    product_name: "Rosa Imortal 2,5: Magia Inata",
    serie_name: "Rosa Imortal",
    author: "Tâni Falabello",
    selo: "Pandora",
    tags: ["Fantasia", "Sobrenatural", "Policial", "Espionagem", "Vampiros"],
    valores: [24.9, 44.9],
    isNew: false,
    thumbnail: require("../assests/capas/rosa-imortal-2-5.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "O que era para ser a viagem de lua de mel transformou-se em uma verdadeira aventura, que ocorre em paralelo ao enredo de “Rosa Imortal: Sangue & Espinhos”. O casal se envolve em situações que comprometem não só a regência de Londres, mas também a de Roma e a de Berlim. Pontuada por alguns flashbacks, eles caem na rede de tramas internacionais, e logo se descobrem em uma fuga alucinada. Cartas de tarô certeiras revelam que o passado humano e a herança judaica de Loren não podiam ser deixados de lado.",
  },
  {
    product_name: "Devoy 1: Kassan",
    serie_name: "Devoy",
    author: "Paula Vendramini",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [24.9, 56.9],
    isNew: false,
    thumbnail: require("../assests/capas/devoy-1.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Ao ter seu Kassan despertado e suas habilidades reveladas, Celebriant assume a posição que esteve predestinada desde o seu nascimento, e inicia sua jornada para se tornar um dos maiores nomes dentro da sociedade dos Ocultos. Porém, uma promessa e as verdades que a sua Intueri lhe aponta acabam a desviando desse caminho. E com os ambiciosos planos futuros sobre sua vida sendo tramados diante dela, Celebriant Devoy não irá aceitar docilmente o seu destino.",
  },
  {
    product_name: "Devoy 2: Intueri",
    serie_name: "Devoy",
    author: "Paula Vendramini",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [24.9, 63.9],
    isNew: false,
    thumbnail: require("../assests/capas/devoy-2.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Após escapar do destino imposto, Celebriant finalmente alcança a tão almejada Base Cultista. No entanto, sua chegada é marcada por uma condição quase fatal. À beira da morte, Phoebe Lynx, dotada dos extraordinários poderes de Curare, usa suas habilidades para curar Celebriant, revelando acidentalmente sua marca de Oculta. Ao descobrirem a verdadeira identidade de Celebriant, os Anciões da Base tomam medidas extremas diante da presença aparentemente intrusa. Agora, a protagonista se vê no centro de uma tensão crescente entre ela e aqueles que detêm o controle. Conseguirá ela superar os desafios impostos e alcançar seu destino almejado? ",
  },
  {
    product_name: "Devoy 3: Curare",
    serie_name: "Devoy",
    author: "Paula Vendramini",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [24.9, 52.9],
    isNew: false,
    thumbnail: require("../assests/capas/devoy-3.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Com o desaparecimento de Saori, Celebriant se vê confrontada com uma escolha que transcende suas próprias vontades. A opção de permanecer ao lado dos Guerreiros e apoiar o Escolhido na luta contra os Ocultos parece ser um caminho de dever. No entanto, a busca por sua irmã implica em arriscar-se na iminência de uma guerra, tornando-se alvo de um imperador determinado a capturá-la. Neste momento crucial, as decisões de Celebriant vão muito além de simplesmente ouvir sua Intueri ou aceitar seu Kassan. A batalha da primogênita Devoy transcende as fronteiras pessoais, exigindo que ela faça o que acredita ser correto, mesmo que isso signifique desmantelar tudo o que um dia construiu.",
  },
  {
    product_name: "Devoy 4: Quimere",
    serie_name: "Devoy",
    author: "Paula Vendramini",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [24.9, 50.9],
    isNew: false,
    thumbnail: require("../assests/capas/devoy-4.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Após um sobrevivência quase inexplicável, Celebriant se encontra diante de uma corrida contra o tempo para salvar Phoebe da morte iminente.\nEnquanto luta para manter a amiga viva, é assombrada por um perseguidor implacável, determinado a tê-la nas suas mãos a qualquer custo. Com seu destino finalmente revelado e seus objetivos de vida claramente definidos, ela enfrenta a difícil escolha de seguir em frente, mesmo diante das potenciais perdas iminentes.\nConseguirá ela superar os desafios que se apresentam, ou sucumbirá diante das ameaças que pairam sobre ela?",
  },
  {
    product_name: "Devoy 5: Imperi",
    serie_name: "Devoy",
    author: "Paula Vendramini",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [24.9, 46.9],
    isNew: false,
    thumbnail: require("../assests/capas/devoy-5.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Em uma corrida frenética contra o inexorável passar do tempo, Celebriant, Saori e Ário embarcam rumo às Ruínas, determinados a desvendar os mistérios contidos no terceiro Manuscrito. Enquanto o trio enfrenta desafios cada vez mais complexos, Nicholas trilha seu próprio caminho em busca de autoconhecimento, enquanto Lune, com suas astutas artimanhas, mantém todos alerta para os desafios que se aproximam. À medida que a batalha final se avizinha, Celebriant se vê confrontada com uma pergunta crucial: quem são os Escolhidos?",
  },
  {
    product_name: "Almakia 1: A Vilashi e os dragões",
    serie_name: "Almakia",
    author: "Lhaisa Andria",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [39.9, 85.9],
    isNew: false,
    thumbnail: require("../assests/capas/almakia-1.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Mesmo dentro dos limites de Almakia nem todos nascem com a capacidade de manejar um almaki. Esses poderes, representações do que encontramos na natureza em todos os outros domínios conhecidos, estão presentes no sangue e conservados nos clãs de manejadores. Foi assim que o Povo Almakin se estruturou, e consequentemente, essa estrutura também estabeleceu posições sociais. Então, no ápice da soberania da Sociedade Almaki, uma pequena mudança surgiu. Porém, pequenas mudanças podem tomar o rumo da grandeza, e para os Dragões podem determinar o que eles farão com o destino de Almakia.",
  },
  {
    product_name: "Almakia 2: Além dos Segredos",
    serie_name: "Almakia",
    author: "Lhaisa Andria",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [34.9, 71.9],
    isNew: false,
    thumbnail: require("../assests/capas/almakia-2.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Após perderem uma importante aliada e serem abandonados pelo seu líder, os Dragões perdem também seus títulos e enfrentam a realidade de não serem mais bem-vindos no Domínio onde nasceram. Sem escolha, eles ajudam Garo-lin na missão de proteger os vilashis e de continuar o trabalho começado por Kandara.\nSerá que a princesa conseguirá voltar? Será que o Dragão de Fogo se perdeu, seguindo o caminho da sua Família? Indo além dos Segredos, eles encontrarão muito mais do que amigos e inimigos. Nessa jornada, passado e presente precisam se unir para que os Dragões possam novamente ditar o futuro de Almakia.",
  },
  {
    product_name: "Almakia 3: Instituto Dul'Maojin",
    serie_name: "Almakia",
    author: "Lhaisa Andria",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [24.9, 49.9],
    isNew: false,
    thumbnail: require("../assests/capas/almakia-3.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "A nova e complexa missão que se desenrola diante de Garo-lin e os Dragões agora se divide em duas frentes cruciais: a busca pelos verdadeiros Dragões, essenciais para que Kanadi enfrente seu oposto: enquanto simultaneamente buscam adentrar o coração de Almakia para alertar os almakins sobre uma ameaça iminente. O desvendar dos mistérios que as imponentes estruturas do Instituto Dul’Maojin guardam revela descobertas contínuas. Além disso, movimentos intrigantes transpassam Além-Mar, gradualmente trazendo à tona verdades que deveriam permanecer esquecidas. Um pensamento ancestral clama por ressurgir e ser revigorado, tornando-se crucial para a preservação do futuro de Almakia.",
  },
  {
    product_name: "Almakia 4: Instituto Dul'Maojin",
    serie_name: "Almakia",
    author: "Lhaisa Andria",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Sociedade Mágica", "Poderes"],
    valores: [34.9, 49.9],
    isNew: false,
    thumbnail: require("../assests/capas/almakia-4.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Será que os novos, e os antigos, Dragões conseguirão eliminar toda a ameaça que se formou com o almaki corrompido? Podemos confiar em Kronar? Como será Almakia depois desta batalha? Ainda existirá Almakia? Enquanto enfrentam dilemas sobre a confiança na Senhora da Capital do Fogo, Garo-lin se vê compelida a desviar seu olhar do futuro, mergulhando nas entranhas do passado para desvendar as origens daqueles que, até então, moldavam o destino de Almakia. Sob a liderança do Almaki puro, a vilashi e os Novos Dragões se unem em uma tentativa desesperada de resgatar antigos aliados e confrontar uma ameaça maior do que o mero orgulho dos almakins.",
  },
  {
    product_name: "Luminari",
    serie_name: "Luminari",
    author: "Luminaris (Autores Lumus)",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Multiversos de contos", "Antologias Fantásticas"],
    valores: [0, 54.9],
    isNew: false,
    thumbnail: require("../assests/capas/luminari-roxo.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Dissidentes de um mundo extinto, os Luminari carregam dentro de si o fogo da criação, que se expandiu em universos diferentes, cada qual com sua peculiaridade. Nestes mundos, homens encantam dragões, poderes são desafiados, títulos de nobreza são questionados, a magia perdura e vampiros sofrem com a perda da humanidade. Tudo isso, sentados à mesa de uma singela padaria, onde se servem mistérios...\nUm grupo de escritores brasileiros de literatura fantástica reunido, os Luminari resolveram que seus mundos poderiam falar um pouco por si, e aqui reunimos alguns desses pergaminhos...",
  },
  {
    product_name: "Luminari Pandora",
    serie_name: "Luminari",
    author: "Luminaris (Autores Lumus)",
    selo: "Pandora",
    tags: ["Fantasia", "Multiversos de contos", "Antologias Fantásticas"],
    valores: [0, 49.9],
    isNew: false,
    thumbnail: require("../assests/capas/luminari-pandora.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Com a Lumus Editora, a caixa de Pandora se abre novamente, desta vez para nos brindar com o dom da escrita inspirado pela inteligência de Pandora e entregar uma seleção de contos especial, focadas no protagonismo feminino de fantasia.\nAfinal de contas, temos mulheres guerreiras, temos aventureiras, temos sonhadoras, temos espiãs, temos manejadoras de almaki, temos ocultas, temos princesas... mas, acima de tudo, temos mulheres! E essas protagonistas fortes, desenhadas pelas letras dos Luminari, merecem ser ouvidas!",
  },
  {
    product_name: "Luminari Codex Kepler",
    serie_name: "Luminari",
    author: "Luminaris (Autores Lumus)",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Multiversos de contos", "Antologias Fantásticas"],
    valores: [0, 57.9],
    isNew: false,
    thumbnail: require("../assests/capas/luminari-codex-kepler.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Dissidentes de um mundo extinto, os Luminari carregam dentro de si o fogo da criação, que se expandiu em universos diferentes, cada qual com sua peculiaridade. Nestes mundos novos que se abriram com a fantástica mescla entre magia e tecnologia, temos cientistas inescrupulosos, exploradores espaciais, robôs sencientes, fadas em versões inusitadas, assim como burocratas espaciais cansados de sua rotina enfadonha. Mas a magia e a tecnologia se juntam para instrumentar os nossos protagonistas, que enfrentam o que há de mais importante: a manutenção da vida, em qualquer forma que ela se apresente.",
  },
  {
    product_name: "Luminari Pirilimpimpim",
    serie_name: "Luminari",
    author: "Luminaris (Autores Lumus)",
    selo: "Pirilimpimpim",
    tags: ["Fantasia", "Multiversos de contos", "Antologias Fantásticas"],
    valores: [0, 29.9],
    isNew: true,
    thumbnail: require("../assests/capas/luminari-pirilimpimpim.jpg"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Neste apanhado de pequenas histórias fantásticas, os Luminari abriram as portas da imaginação para criar contos infantis cheios de diversão, magia e emoção. Prepare-se para embarcar em uma jornada repleta de aventuras mágicas, personagens incríveis e histórias que aquecem o coração. Cada página é um convite para explorar mundos fantásticos, conhecer criaturas curiosas, viver desafios heroicos e descobrir que a amizade, a coragem e a imaginação podem transformar qualquer história - e qualquer leitor. Seja você um pequeno aventureiro ou uma grande sonhadora, aqui dentro há um conto esperando por você!",
  },
  {
    product_name: "O Gato Guardião das Histórias Encantadas",
    serie_name: "Pirilimpimpim",
    author: "Lhaisa Andria",
    selo: "Pirilimpimpim",
    tags: ["Fantasia", "Infantil", "Ilustrado", "Conto de fadas", "Magia"],
    valores: [0, 29.9],
    isNew: true,
    thumbnail: require("../assests/capas/o-gato-guardiao.png"), //falta
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Conheça Pirilim Pimpim, o gato guardião das Histórias Encantadas, um gato preto que vivia na biblioteca mágica de Pimpim. Em sua primeira aventura, ele junta forças com a Fada Madrinha, os Três Porquinhos e o Saci Pererê para trazer de volta as crianças ao hábito da leitura. Aqui é apenas o ponto de partida para uma viagem mágica!",
  },
  {
    product_name: "Lacunas entre mundos",
    serie_name: "Lacunas",
    author: "Gabriella Veloso Biscoli",
    selo: "Pandora",
    tags: ["Fantasia", "Infantojuvenil", "Mundo mágico", "Poderes", "Magia"],
    valores: [0, 64.9],
    isNew: true,
    thumbnail: require("../assests/capas/lacunas-entre-mundos.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Três amigas inseparáveis encontram muito mais do que esperavam ao irem estudar na biblioteca da cidade: um livro com misteriosas instruções sobre um mundo mágico. Ao seguir o que ele diz, um portal se revela, transportando-as para um mundo extraordinário, repleto de seres, segredos e perigos. Nesse lugar, elas descobrem que possuem poderes únicos e que só juntas podem cumprir a missão dada por um imperador: salvar não apenas aquele lugar encantado, mas também o próprio mundo de onde vieram. Entre desafios, amizade e coragem, as três terão que aprender a confiar em si mesmas e no poder que compartilham, antes que seja tarde demais.",
  },
  {
    product_name: "A lenda de Elvengray: Um novo início",
    serie_name: "Elvengray",
    author: "Simone S. Miranda",
    selo: "Autores Lumus",
    tags: ["Fantasia", "Novos Guardiões", "Tecnologia", "Magia", "Luz e Trevas"],
    valores: [0, 64.9],
    isNew: true,
    thumbnail: require("../assests/capas/lenda-elvengray.png"),
    product_card_colors: ["#81B4B2", "#2A2928"],
    description:
      "Elvengray está novamente à beira da guerra. Os Novos Guardiões partem em uma jornada, à procura de aliados para a batalha final, mas seu grande rival, o Imperador Luther, não permitirá que sua viagem seja pacífica. Em meio a incessantes adversidades e reviravoltas, são constantemente bombardeados com novas informações sobre a missão e sobre seu inimigo, escondendo um grande mistério por detrás das atitudes confusas de seu oponente. Alie-se aos sete jovens mais poderosos de Elvengray e tente descobrir as conspirações, os espiões infiltrados e as farsas, até que a guerra seja, finalmente, declarada.",
  },
];
